<template>
    <v-layout justify-center>
        <v-responsive max-width="960" width="100%" height="100%" class="px-3 mx-n3">
            <list-heading title="채팅상담 상담내역 목록" v-model="showsSearch" showsFilterButton />

            <chat-room-list-search v-bind="{ showsSearch }" />

            <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" style="overflow: hidden">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.owner`]="{ value }">
                    <template v-if="value.user">
                        <span> {{ value.user?.name || "-" }} ({{ value.user?.username || "-" }}) </span>
                    </template>
                    <template v-else> 비회원 ({{ value?.sessionId }}) </template>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn small text icon tile :to="`/console/chat/rooms/${item._id}`">
                        <v-icon small> mdi-eye </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ChatRoomListSearch from "@/components/console/chat/rooms/list/chat-room-list-search.vue";

export default {
    components: {
        ListHeading,
        ChatRoomListSearch,
    },
    data: () => ({
        rooms: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return [...this.rooms];
        },
        headers() {
            return [
                {
                    width: +60,
                    text: "#",
                    value: "index",
                    align: "end",
                },
                {
                    width: 160,
                    text: "사용자",
                    value: "owner",
                    cellClass: "text-truncate max-width-0",
                },
                {
                    text: "마지막 메시지",
                    value: "message__last.content",
                    cellClass: "text-truncate max-width-0",
                },
                {
                    width: +70,
                    text: "메시지\r\n개수",
                    value: "_messages.length",
                    align: "end",
                    formatter: (value = 0) => value.format(),
                },
                {
                    width: 100,
                    text: "생성일시",
                    value: "createdAt",
                    formatter: (value) => value?.toDateTime?.(),
                },
                {
                    width: 100,
                    text: "갱신일시",
                    value: "updatedAt",
                    formatter: (value) => value?.toDateTime?.(),
                },
                {
                    width: +60,
                    text: "",
                    value: "actions",
                },
            ].map((item, index, array) => ({ ...item, divider: index != array.length - 1, cellClass: (item.cellClass || "") + " caption", formatter: item.formatter ?? ((value) => value ?? "-") }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, rooms } = await api.console.chat.rooms.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.rooms = rooms.map((item, index) => ({ index: summary.totalCount - (this.page - 1) * this.limit - index, ...item }));
            } finally {
                this.loading = false;
            }
        },

        async update(room) {
            if (this.loading) return;
            else this.loading = true;

            try {
                room = (await api.console.chat.rooms.put(room))?.room;
                this.updateItem(room);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(room) {
            const index = this.rooms.findIndex(({ _id }) => _id == room._id);
            if (0 <= index) this.rooms.splice(index, 1, room);
            else {
                this.rooms = [room, ...this.rooms];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
}
</style>
